import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import React, { ChangeEvent, FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import {
  COLOR_BLACK,
  COLOR_GREY_11,
  COLOR_GREY_8,
  COLOR_SECONDARY_LIGHT,
} from "shared/theme/colors";
import { AddIcon } from "shared/theme/icons/AddIcon";
import { TrashIcon } from "shared/theme/icons/TrashIcon";
import { useBroadcastDetails } from "../../context";
import SkeletonBroadcastContent from "./skeleton";
import {
  StyledButton,
  StyledTransitionGroup,
  StyledContainer,
  StyledDeleteButton,
} from "./styled";

const Actions: FC = () => {
  const {
    actionBlocks,
    setActionBlocks,
    isLoadingBroadcastDetails,
    isReadOnlyMode,
  } = useBroadcastDetails();

  const onChangeText = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
  ) => {
    const newContent = actionBlocks.map((item, i) =>
      index === i ? { ...item, text: e.target.value } : item,
    );

    setActionBlocks(newContent);
  };

  const onChangeUrl = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
  ) => {
    const newContent = actionBlocks.map((item, i) =>
      index === i ? { ...item, url: e.target.value } : item,
    );

    setActionBlocks(newContent);
  };

  const onRemoveBlock = (index: number) => {
    const newItems = [
      ...actionBlocks.slice(0, index),
      ...actionBlocks.slice(index + 1),
    ];
    setActionBlocks(newItems);
  };

  return (
    <ContentSection title="CTA's">
      {isLoadingBroadcastDetails ? (
        <SkeletonBroadcastContent />
      ) : (
        <>
          {!actionBlocks.length ? (
            <Typography variant="bodySMedium" color={COLOR_GREY_8}>
              Currently, no CTA have been added
            </Typography>
          ) : (
            <StyledTransitionGroup>
              {actionBlocks.map((item, index) => (
                <Collapse key={index}>
                  <StyledContainer>
                    <TextField
                      id={`text-${index}`}
                      label="CTA text*"
                      placeholder="Click here to edit text"
                      fullWidth
                      required
                      value={actionBlocks[index].text}
                      onChange={(e) => onChangeText(e, index)}
                      labelColor={COLOR_BLACK}
                      disabled={isReadOnlyMode}
                    />
                    <TextField
                      id={`url-${index}`}
                      label="CTA URL*"
                      placeholder="Click here to edit url"
                      fullWidth
                      required
                      value={actionBlocks[index].url}
                      onChange={(e) => onChangeUrl(e, index)}
                      labelColor={COLOR_BLACK}
                      disabled={isReadOnlyMode}
                    />
                    {actionBlocks.length > 0 && (
                      <StyledDeleteButton
                        onClick={() => !isReadOnlyMode && onRemoveBlock(index)}
                      >
                        <TrashIcon color={COLOR_SECONDARY_LIGHT} />
                        <Typography variant="bodySMedium" color="#F44336">
                          Remove
                        </Typography>
                      </StyledDeleteButton>
                    )}
                  </StyledContainer>
                </Collapse>
              ))}
            </StyledTransitionGroup>
          )}

          <StyledButton
            color="secondary"
            variant="outlined"
            title="Add New"
            size="small"
            icon={<AddIcon color={COLOR_GREY_11} />}
            onClick={() => {
              setActionBlocks([...actionBlocks, { text: "", url: "" }]);
            }}
            disabled={isReadOnlyMode}
          />
        </>
      )}
    </ContentSection>
  );
};

export default Actions;
